export function textContentUpgrade(cimDoc) {
    var _a;
    /* eslint-disable no-param-reassign */
    for (const panel of cimDoc.document.panels) {
        for (const textArea of (_a = panel.textAreas) !== null && _a !== void 0 ? _a : []) {
            if (textArea.textFields) {
                textArea.content = textArea.textFields;
                delete textArea.textFields;
            }
        }
    }
    /* eslint-enable no-param-reassign */
    return cimDoc;
}
//# sourceMappingURL=textContentUpgrade.js.map